"use client";

import { useTranslation } from "@/lib/i18n/context";

const logos = [
  // Todoist
  (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" key="todoist">
      <rect x="3" y="3" width="30" height="30" rx="6" fill="#E44332" />
      <path d="M11 17l3 3 7-8" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  // Calendar
  (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" key="cal">
      <rect x="4" y="4" width="28" height="28" rx="4" fill="#FFFFFF" stroke="#1A1815" strokeWidth="1.4" />
      <rect x="4" y="4" width="28" height="7" rx="4" fill="#1A1815" />
      <rect x="4" y="9" width="28" height="2" fill="#1A1815" />
      <text x="18" y="25" textAnchor="middle" fontFamily="Fraunces, serif" fontSize="12" fontWeight="500" fill="#1A1815">20</text>
    </svg>
  ),
  // Mail
  (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" key="mail">
      <rect x="4" y="8" width="28" height="20" rx="2" />
      <path d="M4 10l14 11L32 10" />
    </svg>
  ),
];

export function IntegrationsSection() {
  const { t } = useTranslation();
  const i = t.landing.cover.integrations;

  return (
    <section className="relative z-[2] py-24 md:py-[100px] px-6 md:px-12">
      <div className="max-w-[1320px] mx-auto">
        <div className="text-center max-w-[640px] mx-auto">
          <div className="kicker-mono inline-flex items-center gap-2.5 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--terracotta)]" /> {i.kicker}
          </div>
          <h2
            className="font-display leading-[1.04] tracking-[-0.02em] text-balance"
            style={{ fontSize: "clamp(36px, 3.6vw, 48px)", fontWeight: 380 }}
          >
            {i.headline}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mt-10">
          {i.items.map((item, idx) => (
            <div
              key={item.name}
              className="bg-[var(--paper-2)] border border-[var(--rule)] rounded-[16px] p-8 flex flex-col min-h-[220px]"
              style={{ color: idx === 2 ? "var(--terracotta)" : "var(--ink)" }}
            >
              <div className="w-9 h-9 mb-5 flex items-center justify-center">{logos[idx]}</div>
              <h3
                className="font-display text-[22px] text-[var(--ink)] tracking-[-0.01em] mb-2.5"
                style={{ fontWeight: 400 }}
              >
                {item.name}
              </h3>
              <p className="text-sm leading-[1.55] text-[var(--ink-soft)] m-0 text-pretty">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="font-mono text-[11px] tracking-[0.14em] text-[var(--ink-soft)] text-center mt-8">
          {i.foot}
        </div>
      </div>
    </section>
  );
}
